import { render, staticRenderFns } from "./CalculateTabsBri.vue?vue&type=template&id=4c67385a&scoped=true"
import script from "./CalculateTabsBri.vue?vue&type=script&lang=js"
export * from "./CalculateTabsBri.vue?vue&type=script&lang=js"
import style0 from "./CalculateTabsBri.vue?vue&type=style&index=0&id=4c67385a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c67385a",
  null
  
)

export default component.exports